import _extends from "@babel/runtime-corejs3/helpers/extends";import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";var _excluded = ["label", "name", "onChange", "currentValue"];import React from 'react';
import { Checkbox } from "../..";

import { createStyles } from "./styles";

var CheckboxEntity = function CheckboxEntity(_ref)





{var label = _ref.label,name = _ref.name,onChange = _ref.onChange,currentValue = _ref.currentValue,props = _objectWithoutProperties(_ref, _excluded);
  var classes = createStyles(!!(props !== null && props !== void 0 && props.guidelines));

  return /*#__PURE__*/(
    React.createElement("div", { className: classes.checkboxWrapper }, /*#__PURE__*/
    React.createElement(Checkbox, _extends({
      label: label,
      name: name,
      onChange: onChange,
      checked: currentValue === true },
    props))));



};

export default CheckboxEntity;
//# sourceMappingURL=index.js.map